const formRows = [{
    span: 24,
    label: '内容标题',
    component: 'AInput',
    placeholder: '请输入标题',
    prop: 'title',
    allowClear: true
  },
  {
    span: 24,
    label: '模块',
    component: 'ASelect',
    placeholder: '请选择内容所属模块',
    prop: 'module',
    allowClear: true,
    list: []
  },
  {
    span: 24,
    label: '作者',
    component: 'AInput',
    placeholder: '请输入名称',
    prop: 'author',
    allowClear: true,
    disabled: false,
  },
  {
    span: 24,
    label: '封面',
    component: 'AUpload',
    prop: 'picPath' // 首图
  },
  {
    span: 24,
    label: '发布时间',
    component: 'ADate',
    prop: 'publishTime',
    format:"YYYY-MM-DD HH:mm:ss",
    'show-time': true,
  },
  {
    span: 24,
    label: '内容简介',
    component: 'AInput',
    prop: 'summary'
  },
  {
    span: 24,
    label: '内容',
    component: 'RichTextEdit',
    prop: 'content'
  },
  {
    span: 24,
    label: '链接',
    component: 'AInput',
    placeholder: '请输入链接',
    prop: 'link',
    allowClear: true,
    disabled: false
  },
  {
    span: 24,
    label: '文档附件',
    component: 'AUploadMultiple',
    prop: 'annexIds',
    limit: 5,
    fileType: ['txt','doc','wps','docx','xls','xlsx','pdf','txt','doc','wps','docx','xls','xlsx','pdf','mp4','avi'],
    tip: '至多上传五个附件支持txt,doc,wps,docx,xls,xlsx,pdf,txt,doc,wps,docx,xls,xlsx,pdf,mp4,avi等格式'
  }
]
const formRules = {
  title: [{
    required: true,
    message: '标题不能为空',
    trigger: 'blur'
  }],
  module: [{
    required: true,
    message: '模块不能为空',
    trigger: 'blur'
  }],
  summary: [{ min: 1, max: 100, message: '输入的文字不能超过100个', trigger: 'change' }]
}
const limitList = [
  {
    code: 'hotProblem',
    isLimit: true
  },
  {
    code: 'zxSummary',
    isLimit: true
  },
  {
    code: 'abroadData',
    isLink: true
  },
  {
    code: 'huaKnowledgeData',
    isLink: true
  },
  {
    code: 'xwshsxx',
    isLink: true
  },
  {
    code: 'analysisReport'
  },
  {
    code: 'competitionDynamics'
  },
  {
    code: 'trainingLectures'
  },
  {
    code: 'relatedConsultation'
  },
  {
    code: 'policiesRegulations'
  },
  {
    code: 'policiesRegulations'
  },
]
export {
  formRows,
  formRules,
  limitList
}
